
<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Estado Cuentas</h4>
  <button type="button" class="close" aria-label="Close" (click)="CerrarModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div id="save-pdf" class="card-test">
    <div class="">
      <img id="logo" class="login-img" src="assets/images/logohori.png" />
    </div>
    <div class="modal-body d-flex justify-content-between align-items-center">
      <h5 class="card-title text-uppercase test-letras">Estado Cuenta Banca Virtual - Riobamba</h5>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th scope="col" class="text-uppercase border-top-none text-right">Fecha</th>
          <th scope="col" class="text-uppercase border-top-none text-right">Documento</th>
          <th scope="col" class="text-uppercase border-top-none text-right">Transacción</th>
          <th scope="col" class="text-uppercase border-top-none text-right">Valor</th>
          <th scope="col" class="text-uppercase border-top-none text-right">Saldo</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let fila of movimientos">
          <td class="text-right">{{ fila?.fecha}}</td>
          <td class="text-right">{{ fila?.documento }}</td>
          <td class="text-right">{{ fila?.transaccion }}</td>
          <td class="text-right">{{ fila?.valor}}</td>
          <td class="text-right">{{ fila?.saldo}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary mr-2" (click)="Descargar()">Descargar</button>
  <button type="button" class="btn btn-secondary" (click)="CerrarModal()">Cancelar</button>
</div>

